import moment from 'moment'
import router from '../../router'
import apiClient from '@/services/axios'
import { i18n } from '@/localization'
import Vue from 'vue'
import _ from 'lodash'

const actions = {
  async GETVOUCHERLIST ({ commit, rootState }, payload) {
    try {
      commit('SET_LOADING_TABLE', true)
      // const { from, to } = rootState.discounts.rangeDate
      // const voucherCode = rootState.discounts.keywordSearch
      const {
        page = 1,
        limit = 20,
        voucher_code,
        from,
        to,
      } = payload
      const { data: response } = await apiClient({
        method: 'get',
        url: '/promotion/private/vouchers',
        params: {
          page,
          limit,
          from,
          to,
          voucher_code,
        },
      })
      const pagination = { ...rootState.discounts.pagination }
      pagination.total = response.total[0].voucher
      pagination.pageSize = limit
      pagination.current = page
      commit('SET_PAGINATION', pagination)
      commit('SET_VOUCHER_LIST', response.data)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      commit('SET_LOADING_TABLE', false)
    }
  },

  async getProductList ({ commit, rootState, dispatch }, payload) {
    try {
      commit('SET_LOADING_DISCOUNT', true)
      const options = {
        method: 'get',
        url: '/products/private/labels',
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const response = await apiClient(options)
      commit('SET_PRODUCT_LIST', response.data.data)
      // dispatch('getResellerList')
    } catch (err) {
      console.log(err)
    }
  },

  async getResellerList ({ commit, rootState, dispatch }, payload) {
    try {
      const options = {
        method: 'get',
        url: `/admin/resellers/${rootState.app.id}`,
      }
      const response = await apiClient(options)
      commit('SET_RESELLER_LIST', response.data.data)
    } catch (e) {
      console.log(e)
    } finally {
      commit('SET_LOADING_DISCOUNT', false)
    }
  },

  async addDiscountCode ({ commit, rootState, dispatch }, payload) {
    commit('SET_LOADING_DISCOUNT', true)
    const product = []
    const allStore = []
    const selectedStore = []
    const sliceProduct = []
    const brands = []
    const courier_list = []
    let sliceBrand = null
    for (const i in payload.product_list) {
      const index = payload.product_list[i].indexOf('_')
      sliceProduct.push(payload.product_list[i].slice(0, index))
    }

    /** set product */
    for (const i in rootState.discounts.productList) {
      if (_.find(sliceProduct, function(o) { return o === rootState.discounts.productList[i].product_title })) {
        product.push(rootState.discounts.productList[i].uuid)
      }
    }

    /** set all_store */
    for (const i in rootState.discounts.resellerList) {
      allStore.push(rootState.discounts.resellerList[i].seller_hashid)
    }
    /** set selected store */
    for (const i in rootState.discounts.resellerList) {
      if (_.find(payload.store_list, function(o) { return o === rootState.discounts.resellerList[i].store_name })) {
        selectedStore.push(rootState.discounts.resellerList[i].seller_hashid)
      }
    }

    for (const i in rootState.discounts.courierList) {
      if (_.find(payload.courier_list, function(o) { return o === rootState.discounts.courierList[i].label })) {
        courier_list.push(rootState.discounts.courierList[i].value)
      }
    }

    const setReferenceList = (type) => {
      switch (type) {
        case 2:
          return product

        case 4:
          // eslint-disable-next-line
          const index = payload.brand_list.indexOf('_')
          sliceBrand = payload.brand_list.slice(0, index)
          /** Set brands */
          for (const i in rootState.discounts.brands) {
            if (rootState.discounts.brands[i].brand_title === sliceBrand) {
              brands.push(rootState.discounts.brands[i].uuid)
            }
          }
          return brands

        default:
          return []
      }
    }

    try {
      const voucher_code = payload.code
      const type_id = payload.type_id
      const value = Number(payload.discount_value) // transaction_data
      const type = payload.discount_type // // transaction_data
      const min_transaction = Number(payload.min_transaction) // // transaction_data
      const max_discount = Number(payload.max_discount) // transaction_data
      const from = moment(payload.validity[0]).unix() // validity
      const until = moment(payload.validity[1]).unix() // validity
      const f_combined = payload.f_combined
      const f_allstore = payload.f_allstore
      const store_list = !payload.f_allstore ? selectedStore : allStore
      const qty = Number(payload.qty)
      const reference_list = setReferenceList(payload.type_id)
      const channel_id = payload.channel_id
      const preparingData = {
        voucher_code,
        type_id,
        transaction_data: {
          value,
          type,
          min_transaction,
          max_discount,
        },
        validity: {
          from,
          until,
        },
        f_combined,
        f_allstore,
        store_list,
        qty,
        reference_list,
        courier_list: payload.type_id === 3 ? courier_list : [],
        channel_id,
      }
      const body = [preparingData]
      const options = {
        method: 'post',
        url: '/promotion/private/vouchers',
        data: body,
      }
      await apiClient(options)
      router.push('/discounts')
      Vue.prototype.$notification.success({
        message: i18n.t('notification.successAddDiscount'),
      })
    } catch (err) {
      switch (err.response.status) {
        case 409:
          Vue.prototype.$notification.error({
            message: i18n.t('notification.duplicateVoucherCode'),
          })
          break
        case 400:
          Vue.prototype.$notification.error({
            message: err.response?.data?.message || i18n.t('authForm.systemBusy'),
          })
          break
        default:
          Vue.prototype.$notification.error({
            message: i18n.t('authForm.systemBusy'),
          })
          break
      }
      // router.push('/discounts/add-disc-code')
    } finally {
      commit('SET_LOADING_DISCOUNT', false)
    }
  },

  async deleteVoucher ({ commit, rootState, dispatch }, payload) {
    try {
      commit('SET_LOADING_TABLE', true)
      const uuids = []
      uuids.push(payload)
      const options = {
        method: 'delete',
        url: '/promotion/private/vouchers',
        data: {
          voucher_uuids: uuids,
        },
      }
      const response = await apiClient(options)
      return Promise.resolve(response)
    } catch (err) {
      console.log(err)
    } finally {
      commit('SET_LOADING_TABLE', false)
    }
  },

  async getBrands ({ commit }, payload) {
    try {
      commit('SET_LOADING_DISCOUNT', true)
      const options = {
        method: 'get',
        url: '/brands/private',
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const { data: response } = await apiClient(options)
      commit('SET_BRANDS', response.data)
    } catch (err) {
      console.log(err)
    } finally {
      commit('SET_LOADING_DISCOUNT', false)
    }
  },

  async GETCOURIERLIST ({ commit }) {
    try {
      commit('SET_LOADING_DISCOUNT', true)
      const { data: response } = await apiClient({
        method: 'get',
        url: '/data/private/courier',
        headers: {
          'Content-Type': 'application/json',
        },
      })
      commit('SET_COURIER_LIST', response.list)
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      commit('SET_LOADING_DISCOUNT', false)
    }
  },

  async GETVOUCHERDETAIL ({ commit }, payload) {
    try {
      commit('SET_LOADING_DISCOUNT', true)
      const { id } = payload
      const { data: response } = await apiClient.get(`/promotion/private/vouchers/${id}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      commit('SET_LOADING_DISCOUNT', false)
    }
  },

  async EDITVOUCHER ({ commit, rootState }, payload) {
    const product = []
    const allStore = []
    const selectedStore = []
    const sliceProduct = []
    const brands = []
    let sliceBrand = null
    const courier_list = []
    for (const i in payload.product_list) {
      const index = payload.product_list[i].indexOf('_')
      sliceProduct.push(payload.product_list[i].slice(0, index))
    }

    /** set product */
    for (const i in rootState.discounts.productList) {
      if (_.find(sliceProduct, function(o) { return o === rootState.discounts.productList[i].product_title })) {
        product.push(rootState.discounts.productList[i].uuid)
      }
    }

    /** set all_store */
    for (const i in rootState.discounts.resellerList) {
      allStore.push(rootState.discounts.resellerList[i].seller_hashid)
    }
    /** set selected store */
    for (const i in rootState.discounts.resellerList) {
      if (_.find(payload.store_list, function(o) { return o === rootState.discounts.resellerList[i].store_name })) {
        selectedStore.push(rootState.discounts.resellerList[i].seller_hashid)
      }
    }

    /** set courier list */
    for (const i in rootState.discounts.courierList) {
      if (_.find(payload.courier_list, function(o) { return o === rootState.discounts.courierList[i].label })) {
        courier_list.push(rootState.discounts.courierList[i].value)
      }
    }

    const setReferenceList = (type) => {
      switch (type) {
        case 2:
          return product

        case 4:
          // eslint-disable-next-line
          const index = payload.brand_list.indexOf('_')
          sliceBrand = payload.brand_list.slice(0, index)
          /** Set brands */
          for (const i in rootState.discounts.brands) {
            if (rootState.discounts.brands[i].brand_title === sliceBrand) {
              brands.push(rootState.discounts.brands[i].uuid)
            }
          }
          return brands

        default:
          return []
      }
    }

    try {
      commit('SET_LOADING_DISCOUNT', true)
      const uuid = payload.uuid
      const voucher_code = payload.code
      const type_id = payload.type_id
      const value = Number(payload.discount_value) // transaction_data
      const type = payload.discount_type // // transaction_data
      const min_transaction = Number(payload.min_transaction) // // transaction_data
      const max_discount = Number(payload.max_discount) // transaction_data
      const from = moment(payload.validity[0]).unix() // validity
      const until = moment(payload.validity[1]).unix() // validity
      const f_combined = payload.f_combined
      const f_allstore = payload.f_allstore
      const store_list = !payload.f_allstore ? selectedStore : allStore
      const qty = Number(payload.qty)
      const reference_list = setReferenceList(payload.type_id)
      const channel_id = payload.channel_id
      const preparingData = {
        uuid,
        voucher_code,
        type_id,
        transaction_data: {
          value,
          type,
          min_transaction,
          max_discount,
        },
        validity: {
          from,
          until,
        },
        f_combined,
        f_allstore,
        store_list,
        qty,
        reference_list,
        courier_list: payload.type_id === 3 ? courier_list : [],
        channel_id,
      }
      const body = [preparingData]
      const options = {
        method: 'put',
        url: '/promotion/private/vouchers',
        data: body,
      }
      await apiClient(options)
      router.push('/discounts')
      // return Promise.resolve(response)
      // router.push({ path: '/discounts', query: { payload: rootState.discounts.pagination } })
      Vue.prototype.$notification.success({
        message: i18n.t('success edit voucher'),
      })
    } catch (err) {
      switch (err.response.status) {
        case 409:
          Vue.prototype.$notification.error({
            message: i18n.t('notification.duplicateVoucherCode'),
          })
          break
        case 400:
          Vue.prototype.$notification.error({
            message: err.response?.data?.message || i18n.t('authForm.systemBusy'),
          })
          break
        default:
          Vue.prototype.$notification.error({
            message: i18n.t('authForm.systemBusy'),
          })
          break
      }
      // return Promise.reject(error)
    } finally {
      commit('SET_LOADING_DISCOUNT', false)
    }
  },

  async GETUSEDVOUCHER ({ commit }, payload) {
    try {
      // commit('SET_LOADING_DISCOUNT', true)
      const { voucher_code, page, limit } = payload
      const { data: response } = await apiClient({
        method: 'get',
        url: '/promotion/private/vouchers/used',
        params: {
          voucher_code,
          page,
          limit,
        },
      })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      // commit('SET_LOADING_DISCOUNT', false)
    }
  },
}

export default actions
